module.exports = __webpack_public_path__ + "static/media/untucked.686d154b.svg";